import { useEffect, useState } from "react";
import { Gauge, Trophy } from "lucide-react";
import { api, eur } from "../lib/api";

export const AdminDashboard = () => {
  const [d, setD] = useState(null);

  useEffect(() => {
    api.get("/admin/dashboard").then((r) => setD(r.data)).catch(() => {});
  }, []);

  if (!d) return null;

  const cards = [
    { label: "Chiffre d'affaires", value: eur(d.gross) },
    { label: "Votre commission (15 %)", value: eur(d.commission) },
    { label: "Ventes", value: d.sales_count },
    { label: "Clients", value: d.clients },
    { label: "Artistes validés", value: d.artists_approved },
    { label: "Artistes en attente", value: d.artists_pending, warn: d.artists_pending > 0 },
  ];

  return (
    <section className="border border-white/[0.08] bg-surface p-8" data-testid="admin-dashboard">
      <h2 className="flex items-center gap-3 font-display text-2xl font-medium">
        <Gauge className="h-5 w-5 text-amber-500" /> Tableau de bord
      </h2>
      <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
        {cards.map((c) => (
          <div key={c.label} className={`border p-4 ${c.warn ? "border-amber-500/50 bg-amber-500/5" : "border-white/[0.08]"}`}>
            <p className="text-[9px] uppercase tracking-[0.2em] text-zinc-500">{c.label}</p>
            <p className={`mt-2 font-display text-2xl font-black ${c.warn ? "text-amber-400" : "text-white"}`} data-testid={`dash-${c.label}`}>
              {c.value}
            </p>
          </div>
        ))}
      </div>
      {d.top_tracks.length > 0 && (
        <div className="mt-8">
          <p className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-zinc-500">
            <Trophy className="h-4 w-4 text-amber-500/70" /> Morceaux les plus performants
          </p>
          <div className="mt-3 divide-y divide-white/[0.06] border-y border-white/[0.06]" data-testid="dash-top-tracks">
            {d.top_tracks.map((t, i) => (
              <div key={t.title} className="flex items-center gap-4 py-2.5 text-sm">
                <span className="text-outline font-display text-xl font-black">{String(i + 1).padStart(2, "0")}</span>
                <span className="min-w-0 flex-1 truncate font-medium">{t.title} <span className="text-zinc-500">— {t.artist}</span></span>
                <span className="text-xs text-zinc-400">{t.plays} écoutes</span>
                <span className="text-xs font-bold text-amber-400">{t.sales} vente{t.sales > 1 ? "s" : ""}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
};
